/**
 * Get full Strapi URL from path
 * @param {string} path Path of the URL
 * @returns {string} Full Strapi URL
 */
export function getCmsUrl(path = "") {
  return `${
    process.env.NEXT_PUBLIC_CMS_API_URL || "http://localhost:1337"
  }${path}`;
}
